import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Bootstrap 5 base styles. Loaded BEFORE our overrides so theme.css can
// override Bootstrap CSS variables (e.g. --bs-primary, --bs-body-bg) per
// the AquaStar palette.
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import './styles/overrides.css';

import App from './App.tsx';

// P1-WA06 — surface the build stamp on window so on-call can paste
// the SHA from a browser console without rebuilding. The same literal
// is rendered in the AdminLayout footer via <BuildStamp />.
if (typeof window !== 'undefined' && typeof __BUILD__ !== 'undefined') {
  window.__BUILD__ = __BUILD__;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
